import z from 'zod'

export const listSelectionFormSchema = z
  .object({
    toList: z.string().nonempty(),
    fromList: z.string().nonempty(),
  })
  .refine((data) => data.toList !== data.fromList, {
    message: "You can't move items to the same list",
    path: ['toList'],
  })

export type FormValues = z.infer<typeof listSelectionFormSchema>

export const FORM_ID = 'selection-form'
